module.exports = __webpack_public_path__ + "static/img/BO@3x.a0e93816.jpg";